import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, map, take } from 'rxjs/operators';
import { AuthState } from '~app/core/auth/core/auth.state';
import { RoutingService } from '~app/core/navigation';
import { SystemRoles } from '~app/shared/security/system-roles';

@Injectable({
  providedIn: 'root',
})
export class SharedProjectsGuard  {
  constructor(
    private store: Store,
    private routingService: RoutingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.select(AuthState.user).pipe(
      filter(usr => !!usr ),
      take(1), 
      map((user) => {
       const hasGeneralPublic = !!user?.roles?.includes(SystemRoles.roleGeneralPublic);
        if (!hasGeneralPublic) {
          this.routingService.navigateToForbidden(state.url);
          return false;
        }  
        return true;
      }),
    );
  }
}
